import { RegistrationComponent } from "./registration.component";

export const routes = [
  { path: "registration",
    children: [
      { path: "", component: RegistrationComponent, pathMatch: "full" }
    ]}
];
